import { CommonUtilities } from "../../commonUtils";
import Pagination from 'components/Common/newPagination';
import React, { Suspense, useState, useEffect } from "react";
import Drawer from 'react-modern-drawer';
import contractServices from "./contractServices";

export default function ContractTemplate(param: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => { setIsOpen(!isOpen) }
    let [ContractTemplateList, initContractTemplateList] = useState<any[]>([]);
    const [totalRow, inittotalRow] = useState(0);
    let [search, setSearch] = useState("");
    const [selectTemplate, initselectTemplate] = useState<any>([]);

    var payload = {
        "pageNumber": 1,
        "pageSize": 10,
        "searchText": ""
    }
    const apiCall = () => {
        contractServices.countContractTemplate().then((res) => {
            inittotalRow(res)
        })

        if (search !== "") { payload.searchText = search; }
        contractServices.ContractTemplateList(payload).then((res) => {
            initContractTemplateList(res)
        })
    }

    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        apiCall();
    }

    const selectedTemplate = (n: any) => {
        initselectTemplate(n);
        setIsOpen(!isOpen);
        param.selectedTemplate(n);
    }


    return (
        <div>

            <Drawer
                open={param.copyTemplate}
                onClose={toggleDrawer}
                direction='right'
                className='box react-drawer '
                size={800}>

                <div className='ws-7 box pull-right'>
                    <div className="box-header ws-12 pull-left">
                        <h2 className='text-bold'>Contract Templates</h2>
                    </div>

                    <div className="form-format pm">
                        <div className="label-entries" style={{ marginLeft: "15%" }}>
                            <div className="ws-6 ptl">
                                <input type="text" className="input-sm" placeholder="Search" id="filterTemplateList" onChange={(e) => setSearch(e.target.value)} />
                            </div>
                            <div className="ws-6 ptl">
                                <button className="icon-btn edit " onClick={apiCall}>
                                    <i className="fa fa-search"></i> Search
                                </button>
                            </div>
                            {(totalRow > 0) && <div className="ws-12 m0 mt">
                                <h4 className="mb ">Please choose a contract template.</h4>
                                <ul className="ws-12 m0 textboxDropdownList" style={{ listStyle: "none" }}>
                                    {
                                        ContractTemplateList.map((data) => {
                                            return (
                                                <li >
                                                    <label className="pm">
                                                        <input className="ml" type="radio" name="templateName" onClick={() => selectedTemplate(data)} value={data.contractRefNum} />
                                                        {data.contractRefNum} - {data.kontactDisplay}
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                            </div>}
                        </div>

                        {(totalRow === 0) && <div className="alert alert-danger ws-12 mt m0">  No template matched your search criteria </div>}

                        <div className="ws-10 pt pll">{
                            (() => {
                                if (totalRow && totalRow > 10) {
                                    return  <Pagination onPageChange={handleNameOnChange} totalRow={totalRow} />
                                }
                            })()
                        }</div>
                    </div>
                </div>
            </Drawer>

        </div>
    )
}